import * as Sentry from "@sentry/react";

import config from "config";
import { IUser } from "Auth/types";

export class SentryService {
  /*
    Initialize Sentry.
    - Sets the environment and release version
    - Only sends errors from authenticated users
    - Does not send errors when developing locally
  */
  static init() {
    Sentry.init({
      dsn: config.sentry.dsn,
      environment: process.env.REACT_APP_ENV,
      release: process.env.REACT_APP_VERSION,
      autoSessionTracking: false,
      // Filter out requests where no user is set or the application is running locally before sending event to sentry.
      beforeSend(event) {
        if (!event.user) {
          return null;
        }
        if (process.env.NODE_ENV === "development") {
          return null;
        }
        return event;
      },
    });
  }

  //  Add a user to the Sentry scope.
  static setUser(user: IUser) {
    Sentry.configureScope((scope) =>
      scope.setUser({ email: user.attributes.email, id: user.id })
    );
  }

  //  Clear the user from the Sentry scope.
  static clearUser() {
    Sentry.configureScope((scope) => scope.setUser(null));
  }
}
